var _g, _g2, _g3, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMurall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Murall",
    width: 292,
    height: 51.574,
    viewBox: "0 0 292 51.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(285.045 44.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    fill: "#1c1a24",
    d: "M399.66,118.842a3.441,3.441,0,0,1-3.488,3.483,3.337,3.337,0,0,1-2.448-1.006,3.272,3.272,0,0,1-1.02-2.414,3.435,3.435,0,0,1,.995-2.5,3.29,3.29,0,0,1,2.451-1.033,3.447,3.447,0,0,1,2.488,1.02A3.318,3.318,0,0,1,399.66,118.842Zm-.348,0a3.133,3.133,0,0,0-5.341-2.214,2.878,2.878,0,0,0-.92,2.162,3.157,3.157,0,0,0,.9,2.266,2.94,2.94,0,0,0,2.2.921,3.125,3.125,0,0,0,3.162-3.135Z",
    "data-name": "Path 102",
    transform: "translate(-392.705 -115.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(1.763 1.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    fill: "#1c1a24",
    d: "M395.616,116.449a1.755,1.755,0,0,1,1.2.461.1.1,0,0,1,0,.139l-.136.133c-.036.049-.08.045-.127-.006a1.511,1.511,0,0,0-.949-.37,1.426,1.426,0,0,0,0,2.852,1.455,1.455,0,0,0,.949-.368.085.085,0,0,1,.117-.017l.15.13a.1.1,0,0,1,0,.135,1.69,1.69,0,0,1-1.208.483,1.785,1.785,0,1,1,0-3.571Z",
    "data-name": "Path 103",
    transform: "translate(-393.83 -116.449)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    fill: "#1c1a24",
    d: "M265.18,86.893v50.491H252.213V110.551L241.7,127.14h-7.43L223.75,110.48v26.9H210.781V86.893h12.268l14.93,23.658,14.932-23.658Z",
    "data-name": "Path 104",
    transform: "translate(-210.781 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    fill: "#1c1a24",
    d: "M295.254,86.893v31.23a21.522,21.522,0,0,1-1.927,9.6,17.486,17.486,0,0,1-5.045,6.274,19.908,19.908,0,0,1-7.082,3.428,31.3,31.3,0,0,1-16.052,0,19.848,19.848,0,0,1-7.081-3.428,17.491,17.491,0,0,1-5.047-6.274,21.478,21.478,0,0,1-1.929-9.6V86.893H264.06V117.4q0,5.124,2.491,7.14a11.869,11.869,0,0,0,13.246,0q2.489-2.019,2.49-7.14V86.893Z",
    "data-name": "Path 105",
    transform: "translate(-187.932 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    fill: "#1c1a24",
    d: "M284.869,137.384V86.893H305.55a34.11,34.11,0,0,1,7.325.794,18.179,18.179,0,0,1,6.447,2.74,14.466,14.466,0,0,1,4.594,5.229,17.443,17.443,0,0,1,1.752,8.26,20.077,20.077,0,0,1-.7,5.589A14.608,14.608,0,0,1,323,113.759a13.409,13.409,0,0,1-2.979,3.138,17.677,17.677,0,0,1-3.751,2.167L329.8,137.384H315.154l-11.709-16.445h-5.606v16.445Zm12.97-27.266h8.273a6.784,6.784,0,0,0,4.52-1.443,6.5,6.5,0,0,0,0-8.8,6.792,6.792,0,0,0-4.52-1.443h-8.273Z",
    "data-name": "Path 106",
    transform: "translate(-168.785 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    fill: "#1c1a24",
    d: "M313.77,137.384l19.282-50.491H347.07l19.278,50.491H353.027l-2.8-7.938h-20.33l-2.8,7.938Zm19.98-18.753h12.618l-5.047-14.572a20.517,20.517,0,0,1-.632-2.02q-.28-1.081-.631-3.1-.35,2.019-.63,3.1a20.517,20.517,0,0,1-.631,2.02Z",
    "data-name": "Path 107",
    transform: "translate(-152.403 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    fill: "#1c1a24",
    d: "M363.292,86.893v38.586h48.266v11.9H350.323V86.893Z",
    "data-name": "Path 108",
    transform: "translate(-131.684 -86.893)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    fill: "#1c1a24",
    d: "M375.542,86.893V106.7h29.071v11.9H362.576V86.893Z",
    "data-name": "Path 109",
    transform: "translate(-124.738 -86.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    width: 22.76,
    height: 11.902,
    fill: "#1c1a24",
    "data-name": "Rectangle 24",
    transform: "translate(257.114)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    fill: "#1c1a24",
    d: "M265.18,86.893v50.491H252.213V110.551L241.7,127.14h-7.43L223.75,110.48v26.9H210.781V86.893h12.268l14.93,23.658,14.932-23.658Z",
    "data-name": "Path 110",
    transform: "translate(-210.781 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    fill: "#1c1a24",
    d: "M295.254,86.893v31.23a21.522,21.522,0,0,1-1.927,9.6,17.486,17.486,0,0,1-5.045,6.274,19.908,19.908,0,0,1-7.082,3.428,31.3,31.3,0,0,1-16.052,0,19.848,19.848,0,0,1-7.081-3.428,17.491,17.491,0,0,1-5.047-6.274,21.478,21.478,0,0,1-1.929-9.6V86.893H264.06V117.4q0,5.124,2.491,7.14a11.869,11.869,0,0,0,13.246,0q2.489-2.019,2.49-7.14V86.893Z",
    "data-name": "Path 111",
    transform: "translate(-187.932 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    fill: "#1c1a24",
    d: "M284.869,137.384V86.893H305.55a34.11,34.11,0,0,1,7.325.794,18.179,18.179,0,0,1,6.447,2.74,14.466,14.466,0,0,1,4.594,5.229,17.443,17.443,0,0,1,1.752,8.26,20.077,20.077,0,0,1-.7,5.589A14.608,14.608,0,0,1,323,113.759a13.409,13.409,0,0,1-2.979,3.138,17.677,17.677,0,0,1-3.751,2.167L329.8,137.384H315.154l-11.709-16.445h-5.606v16.445Zm12.97-27.266h8.273a6.784,6.784,0,0,0,4.52-1.443,6.5,6.5,0,0,0,0-8.8,6.792,6.792,0,0,0-4.52-1.443h-8.273Z",
    "data-name": "Path 112",
    transform: "translate(-168.785 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    fill: "#1c1a24",
    d: "M313.77,137.384l19.282-50.491H347.07l19.278,50.491H353.027l-2.8-7.938h-20.33l-2.8,7.938Zm19.98-18.753h12.618l-5.047-14.572a20.517,20.517,0,0,1-.632-2.02q-.28-1.081-.631-3.1-.35,2.019-.63,3.1a20.517,20.517,0,0,1-.631,2.02Z",
    "data-name": "Path 113",
    transform: "translate(-152.403 -86.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    fill: "#1c1a24",
    d: "M363.292,86.893v38.586h48.266v11.9H350.323V86.893Z",
    "data-name": "Path 114",
    transform: "translate(-131.684 -86.893)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    fill: "#1c1a24",
    d: "M375.542,86.893V106.7h29.071v11.9H362.576V86.893Z",
    "data-name": "Path 115",
    transform: "translate(-124.738 -86.893)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    width: 22.76,
    height: 11.902,
    fill: "#1c1a24",
    "data-name": "Rectangle 25",
    transform: "translate(257.114 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMurall);
export default __webpack_public_path__ + "static/media/Murall.25ed38cce4cc3713bac0df7bdfa2d796.svg";
export { ForwardRef as ReactComponent };